import { TableCellsIcon } from "@heroicons/react/24/outline"

/**
 * Size chart extension (admin side): which chart the product shows — one of
 * the Size Charts (CMS, type StoreSizeChart), or its category's default
 * ("Inherit from category"), or none — with a preview. The field editor
 * (SizeChartSelect, aldoo-ra/CMS/field-editors/size-chart-select.jsx) is the
 * one a category's default chart is picked with too. The server half is
 * aldoo-na/store/product/extensions/size-chart.
 */
export const StoreProductExtension = {
  id: "size-chart",
  label: "Size Chart",
  description: "A size chart per product, or the category's default",
  icon: TableCellsIcon,
  group: {
    id: "size-chart",
    label: "Size Chart",
    description: "The size chart the product page opens from the size selector. The charts are edited in the CMS (Size Chart); a category's default is set on the category.",
  },
  fields: [
    {
      id: "sizeChart",
      label: "Size chart",
      type: "Text",
      fieldEditor: "SizeChartSelect",
      allowInherit: true,
      default: "inherit",
      description: "A chart, the category's default, or none",
      render: { variant: "full" },
    },
  ],
}
